import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-get-access',
    templateUrl: './dlg-get-access.component.pug',
    styleUrls: ['./dlg-get-access.component.less'],
})
export class DlgGetAccessComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DlgGetAccessComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
    }

    onClose() {
        this.dialogRef.close(false);
    }

    protected onGetAccess(value: number) {
        this.dialogRef.close(value);
    }
}